import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const CaseDetail = ({ user }) => {
  return (
    <Layout user={user}>
      <div className="p-8">
        <h1 className="text-3xl font-bold text-gray-900">Fall-Details</h1>
        <p className="text-gray-600 mt-2">Feature wird noch implementiert</p>
      </div>
    </Layout>
  );
};

export default CaseDetail;
